import type { BattleItem } from "./types";

const battleItems: BattleItem[] = [
  { id: "potion", image: "battle-items/potion.webp", name: "Potion" },
  { id: "x-attack", image: "battle-items/x-attack.webp", name: "X Attack" },
  { id: "x-speed", image: "battle-items/x-speed.webp", name: "X Speed" },
  { id: "fluffy-tail", image: "battle-items/fluffy-tail.webp", name: "Fluffy Tail" },
  { id: "eject-button", image: "battle-items/eject-button.webp", name: "Eject Button" },
  { id: "slow-smoke", image: "battle-items/slow-smoke.webp", name: "Slow Smoke" },
  { id: "full-heal", image: "battle-items/full-heal.webp", name: "Full Heal" },
  { id: "goal-getter", image: "battle-items/goal-getter.webp", name: "Goal-Getter" },
  { id: "shedinja-doll", image: "battle-items/shedinja-doll.webp", name: "Shedinja Doll" },
  { id: "goal-hacker", image: "battle-items/goal-hacker.webp", name: "Goal Hacker" },
];

export default battleItems;
